import { type AdminOrganizationDetail, type AdminOrganizationPage } from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const organizationsEndpoints = {
  /** The clubs grid: organizations with their counters, filterable by verification status. */
  organizations(params: Record<string, string> = {}) {
    const query = new URLSearchParams(params).toString();
    return authenticated<AdminOrganizationPage>(
      `${API_PREFIX}/admin/organizations${query ? `?${query}` : ''}`,
    );
  },

  /** One organization with its members, verification and activity counters. */
  organization(organizationId: string) {
    return authenticated<AdminOrganizationDetail>(
      `${API_PREFIX}/admin/organizations/${organizationId}`,
    );
  },
};
